import React from "react";

const CourseInput = (props) => {

    const handleChange = (e) => {
        props.updateValue(e.target.value);
    }

    return (
        <>
            <div className="input-field">
                <div className="top-input">
                    { props.top }
                    {
                        props.required

                        ?
                            <div className="required">
                                *
                            </div>
                        :
                            <></>
                            
                    }
                </div>
                <input className="bottom-input" type={ "text" } value={ props.value } onChange={ handleChange } required={ props.required } autoComplete={ props.autoComplete } placeholder={ props.placeholder } />
            </div>
        </>
    );
}

export default CourseInput;